import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pt-0 text-left text-h6 font-weight-light" }
const _hoisted_2 = {
  key: 0,
  class: "absolute"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFView = _resolveComponent("PDFView")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_motion_slide_top = _resolveDirective("motion-slide-top")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.pdfSource)
      ? (_openBlock(), _createBlock(_component_PDFView, {
          key: 0,
          source: _ctx.pdfSource,
          page: -1,
          onLoaded: _ctx.onPdfLoaded
        }, null, 8, ["source", "onLoaded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_sheet, {
      height: "80vh",
      "max-height": "80vh",
      class: "pl-2 pr-2 w-auto overflow-y-auto hidden-scrollbar d-flex flex-column bg-blue-grey-lighten-5",
      style: {"min-height":"0"}
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "pt-10n ma-16n text-h5 text-center bg-blue-grey-lighten-4" }, " Original ", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
          return (_openBlock(), _createElementBlock("div", {
            key: page,
            class: "mb-0",
            style: {"position":"relative"}
          }, [
            _createElementVNode("p", _hoisted_1, [
              _createTextVNode(_toDisplayString(page) + " ", 1),
              (_ctx.frames && _ctx.frames[page - 1]?.isReplaced)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "red lighten-1",
                    size: "small",
                    class: "ml-16 center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" mdi-star ")
                    ])),
                    _: 1,
                    __: [0]
                  }))
                : _createCommentVNode("", true),
              (_ctx.frames && _ctx.frames[page - 1]?.isGenerated)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    color: "green lighten-1",
                    size: "small",
                    class: _normalizeClass(['text-left', _ctx.frames[page - 1]?.isReplaced ? 'ml-0' : 'ml-16'])
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" mdi-lightbulb-on-outline ")
                    ])),
                    _: 2,
                    __: [1]
                  }, 1032, ["class"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.frames)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.frames[page - 1]?.isReplaced)
                    ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                        key: 0,
                        class: "pa-2",
                        style: {"position":"absolute","top":"-5","right":"0","width":"80px","z-index":"10"},
                        elevation: "5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PDFView, {
                            clearable: "",
                            source: _ctx.frames[page-1]?.template?.pdfSource,
                            page: _ctx.frames[page-1]?.selectedSlideTemplate?.pageNumber
                          }, null, 8, ["source", "page"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_motion_slide_top]
                      ])
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_PDFView, {
              class: "elevation-5 h-auto w-auto",
              source: _ctx.pdfSource,
              page: page,
              scale: 1.5,
              style: {
                cursor: 'pointer',
            },
              cover: "",
              onClick: ($event: any) => (_ctx.newSelectedFrame(page))
            }, null, 8, ["source", "page", "onClick"])
          ]))
        }), 128))
      ]),
      _: 1,
      __: [2]
    })
  ], 64))
}